import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateDemandDefinition } from '../../common/api/clients/demandDefinitions.api';
import type { SaveDemandDefinitionRequest } from '../../common/api/clients/demandDefinitions.api';
import { queries } from '../../common/api/queryKeys/queries';

interface UpdateDemandDefinitionMutation {
    definitionId: string;
    request: SaveDemandDefinitionRequest;
}

export const useUpdateDemandDefinition = (customerGroupId?: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ definitionId, request }: UpdateDemandDefinitionMutation) =>
            updateDemandDefinition({ id: definitionId, request, customerGroupId }),
        onSuccess: (definition) => {
            queryClient.setQueryData(queries.demandDefinitions.detail(definition.id).queryKey, definition);

            return queryClient.invalidateQueries({ queryKey: queries.demandDefinitions.list._def });
        },
    });
};
